<div class="settings-navigation" data-test="settings-navigation">
  <nav
    mat-tab-nav-bar
    [mat-stretch-tabs]="false"
    color="accent"
    [tabPanel]="tabPanel"
    [mat-stretch-tabs]="false"
  >
    <a mat-tab-link [routerLink]="['/settings', 'barn']" [active]="isBarn$ | async">
      {{ 'settings-navigation.barns' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
